<div class="space"></div>

<div class="lightgray">
	<section id="slider">
		<div class="slide">
			<div class="somos">
				<div class="wrapper">
					<img class="beducation" src="../../../../../assets/img/badge_education.svg" alt="">
					<div class="info anime-element fadeleft-animation">
						<div class="gtitle">
							<img class="igoogle" src="../../../../../assets/img/igoogle.svg" alt=""> 
							<h2>Workspace for Education</h2>
						</div>
						<div class="fluid">
							<div class="piece">
								<h4>{{ 'cloud.title368' | translate }}<span> {{ 'cloud.title369' | translate }}</span></h4>
							</div>
						</div>
					</div>
					<div class="foto">
						<img src="../../../../../assets/img/student1.webp" alt="">
					</div>
					<div class="circle"></div>
				</div>
			</div>
		</div>
	</section>
</div>

<div class="space"></div>

<img class="wave" src="../../../../../assets/img/bg-wave.svg" alt="">
<div class="content-area paddle">
	<div class="wrap">

		<section class="vw_section">

			<div class="flex6 website">
				<div class="elementb box">
					<div class="boxi">
						<div class="scircle"></div>
						<div class="high">
							<div class="pieceup">
								<img class="icloud" src="../../../../assets/img/thumbs.svg" alt="facil">
							</div>
							<div class="piecedown">
								<h2>{{ 'cloud.title370' | translate }}</h2>
							</div>
						</div>
						<div class="low">
							<h3>{{ 'cloud.title371' | translate }}</h3>
							<ul>
								<li>{{ 'cloud.title372' | translate }}</li>
								<li>{{ 'cloud.title373' | translate }}</li>
								<li>{{ 'cloud.title374' | translate }}</li>
							</ul>
						</div>
					</div>
				</div>
				<div class="elementb box">
					<div class="boxi">
						<div class="high">
							<div class="pieceup">
								<img class="iuser" src="../../../../assets/img/user.svg" alt="accesible">
							</div>
							<div class="piecedown">
								<h2>{{ 'cloud.title375' | translate }}</h2>
							</div>
						</div>
						<div class="low">
							<h3>{{ 'cloud.title376' | translate }}</h3>
							<ul>
								<li>{{ 'cloud.title377' | translate }}</li>
								<li>{{ 'cloud.title378' | translate }}</li>
								<li>{{ 'cloud.title379' | translate }}</li>
							</ul>
						</div>
					</div>
				</div>
				<div class="elementb box">
					<div class="boxi">
						<div class="high">
							<div class="pieceup">
								<img class="imoon" src="../../../../../assets/img/versatil-icon.svg" alt="versatil">
							</div>
							<div class="piecedown">
								<h2>{{ 'cloud.title380' | translate }}</h2>
							</div>
						</div>
						<div class="low">
							<h3>{{ 'cloud.title381' | translate }}</h3>
							<ul>
								<li>{{ 'cloud.title382' | translate }}</li>
								<li>{{ 'cloud.title383' | translate }}</li>
								<li>{{ 'cloud.title384' | translate }}</li>
							</ul>
						</div>
					</div>
				</div>
				<div class="elementb box">
					<div class="boxi">
						<div class="high">
							<div class="pieceup">
								<img class="emoon" src="../../../../../assets/img/brain-icon.svg" alt="aprendizaje">
						    </div>
						    <div class="piecedown">
								<h2>{{ 'cloud.title385' | translate }}</h2>
							</div>
						</div>
						<div class="low">
							<h3>{{ 'cloud.title386' | translate }}</h3>
							<ul>
								<li>{{ 'cloud.title387' | translate }}</li>
								<li>{{ 'cloud.title388' | translate }}</li>
								<li>{{ 'cloud.title389' | translate }}</li>
							</ul>
						</div>
					</div>
				</div>
			</div>
		</section>


	</div>
</div>	

<div class="content-area bright">
	<div class="wrap">

		<section class="table">
			<div class="wided">
				<div class="flex m10">
					<h2>{{ 'cloud.title390' | translate }}</h2>
				</div>
				<h3>{{ 'cloud.title391' | translate }}</h3>
			</div>

			<div class="padd">
			<app-accordion>
				<app-accordion-item title="{{ 'cloud.title828' | translate }}">
					<table>
					  <thead>
					    <tr>
					      <th scope="col"></th>
					      <th scope="col">Education</th>
					      <th scope="col">{{ 'cloud.title392' | translate }}</th>
					    </tr>
					  </thead>
					  <tbody>
					    <tr>
					      <td data-label="Funcionalidad">{{ 'cloud.title393' | translate }}</td>
					      <td data-label="Google Workspace"><img class="tick" src="../../../../../assets/img/tick.svg" alt=""></td>
					      <td data-label="Google Workspace con eSource"><img class="tick" src="../../../../../assets/img/tick.svg" alt=""></td>
					    </tr>
					    <tr>
					      <td data-label="Funcionalidad">{{ 'cloud.title394' | translate }}</td>
					      <td data-label="Google Workspace"><img class="tick" src="../../../../../assets/img/tick.svg" alt=""></td>
					      <td data-label="Google Workspace con eSource"><img class="tick" src="../../../../../assets/img/tick.svg" alt=""></td>
					    </tr>
					    <tr>
					      <td data-label="Funcionalidad">{{ 'cloud.title395' | translate }}</td>
					      <td data-label="Google Workspace"><img class="tick" src="../../../../../assets/img/tick.svg" alt=""></td>
					      <td data-label="Google Workspace con eSource"><img class="tick" src="../../../../../assets/img/tick.svg" alt=""></td>
					    </tr>
					    <tr>
					      <td data-label="Funcionalidad">{{ 'cloud.title396' | translate }}</td>
					      <td data-label="Google Workspace"><img class="tick" src="../../../../../assets/img/tick.svg" alt=""></td>
					      <td data-label="Google Workspace con eSource"><img class="tick" src="../../../../../assets/img/tick.svg" alt=""></td>
					    </tr>
					    <tr>
					      <td data-label="Funcionalidad">{{ 'cloud.title397' | translate }}</td>
					      <td data-label="Google Workspace"><img class="tick" src="../../../../../assets/img/tick.svg" alt=""></td>
					      <td data-label="Google Workspace con eSource"><img class="tick" src="../../../../../assets/img/tick.svg" alt=""></td>
					    </tr>
					    <tr>
					      <td data-label="Funcionalidad">{{ 'cloud.title398' | translate }}</td>
					      <td data-label="Google Workspace"><img class="tick" src="../../../../../assets/img/tick.svg" alt=""></td>
					      <td data-label="Google Workspace con eSource"><img class="tick" src="../../../../../assets/img/tick.svg" alt=""></td>
					    </tr>
					    <tr>
					      <td data-label="Funcionalidad">{{ 'cloud.title399' | translate }}</td>
					      <td data-label="Google Workspace"><img class="tick" src="../../../../../assets/img/tick.svg" alt=""></td>
					      <td data-label="Google Workspace con eSource"><img class="tick" src="../../../../../assets/img/tick.svg" alt=""></td>
					    </tr>
					    <tr>
					      <td data-label="Funcionalidad">{{ 'cloud.title400' | translate }}</td>
					      <td data-label="Google Workspace"><img class="tick" src="../../../../../assets/img/tick.svg" alt=""></td>
					      <td data-label="Google Workspace con eSource"><img class="tick" src="../../../../../assets/img/tick.svg" alt=""></td>
					    </tr>
					    <tr>
					      <td data-label="Funcionalidad">{{ 'cloud.title401' | translate }}</td>
					      <td data-label="Google Workspace"></td>
					      <td data-label="Google Workspace con eSource"><img class="tick" src="../../../../../assets/img/tick.svg" alt=""></td>
					    </tr>
					  </tbody>
					</table>
				</app-accordion-item>

				<app-accordion-item title="{{ 'cloud.title829' | translate }}">
					<table>
					  <thead>
					    <tr>
					      <th scope="col"></th>
					      <th scope="col">Education</th>
					      <th scope="col">{{ 'cloud.title392' | translate }}</th>
					    </tr>
					  </thead>
					  <tbody>
					    <tr>
					      <td data-label="Funcionalidad">{{ 'cloud.title402' | translate }}</td>
					      <td data-label="Google Workspace"><p>{{ 'cloud.title403' | translate }}</p></td>
					      <td data-label="Google Workspace con eSource"><p>{{ 'cloud.title404' | translate }}</p></td>
					    </tr>
					    <tr>
					      <td data-label="Funcionalidad">{{ 'cloud.title405' | translate }}</td>
					      <td data-label="Google Workspace"><p>{{ 'cloud.title406' | translate }}</p></td>
					      <td data-label="Google Workspace con eSource"><p>{{ 'cloud.title406' | translate }}</p></td>
					    </tr>
					    <tr>
					      <td data-label="Funcionalidad">{{ 'cloud.title407' | translate }}</td>
					      <td data-label="Google Workspace"><p>{{ 'cloud.title408' | translate }}</p></td>
					      <td data-label="Google Workspace con eSource"><p>{{ 'cloud.title408' | translate }}</p></td>
					    </tr>
					    <tr>
					      <td data-label="Funcionalidad">{{ 'cloud.title409' | translate }}</td>
					      <td data-label="Google Workspace"><img class="tick" src="../../../../../assets/img/tick.svg" alt=""></td>
					      <td data-label="Google Workspace con eSource"><img class="tick" src="../../../../../assets/img/tick.svg" alt=""></td>
					    </tr>
					    <tr>
					      <td data-label="Funcionalidad">{{ 'cloud.title410' | translate }}</td>
					      <td data-label="Google Workspace"><img class="tick" src="../../../../../assets/img/tick.svg" alt=""></td>
					      <td class="tfl" data-label="Google Workspace con eSource">
					      	<img class="tick" src="../../../../../assets/img/tick.svg" alt="">
					      	<p>***</p>
					      </td>
					    </tr>
					    <p>{{ 'cloud.title411' | translate }}</p>
					    <p>{{ 'cloud.title412' | translate }}</p>
					    <p>{{ 'cloud.title413' | translate }}</p>
					  </tbody>
					</table>

				</app-accordion-item>
				<app-accordion-item title="{{ 'cloud.title830' | translate }}">
					<table>
					  <thead>
					    <tr>
					      <th scope="col"></th>
					      <th scope="col">Education</th>
					      <th scope="col">{{ 'cloud.title392' | translate }}</th>
					    </tr>
					  </thead>
					  <tbody>
					    <tr>
					      <td data-label="Funcionalidad">{{ 'cloud.title414' | translate }}</td>
					      <td data-label="Google Workspace"><img class="tick" src="../../../../../assets/img/tick.svg" alt=""></td>
					      <td data-label="Google Workspace con eSource"><img class="tick" src="../../../../../assets/img/tick.svg" alt=""></td>
					    </tr>
					    <tr>
					      <td data-label="Funcionalidad">{{ 'cloud.title415' | translate }}</td>
					      <td data-label="Google Workspace"><img class="tick" src="../../../../../assets/img/tick.svg" alt=""></td>
					      <td data-label="Google Workspace con eSource"><img class="tick" src="../../../../../assets/img/tick.svg" alt=""></td>
					    </tr>
					    <tr>
					      <td data-label="Funcionalidad">{{ 'cloud.title416' | translate }}</td>
					      <td data-label="Google Workspace"><img class="tick" src="../../../../../assets/img/tick.svg" alt=""></td>
					      <td data-label="Google Workspace con eSource"><img class="tick" src="../../../../../assets/img/tick.svg" alt=""></td>
					    </tr>
					    <tr>
					      <td data-label="Funcionalidad">{{ 'cloud.title417' | translate }}</td>
					      <td data-label="Google Workspace"><img class="tick" src="../../../../../assets/img/tick.svg" alt=""></td>
					      <td data-label="Google Workspace con eSource"><img class="tick" src="../../../../../assets/img/tick.svg" alt=""></td>
					    </tr>
					    <tr>
					      <td data-label="Funcionalidad">{{ 'cloud.title418' | translate }}</td>
					      <td data-label="Google Workspace"><img class="tick" src="../../../../../assets/img/tick.svg" alt=""></td>
					      <td data-label="Google Workspace con eSource"><img class="tick" src="../../../../../assets/img/tick.svg" alt=""></td>
					    </tr>
					  </tbody>
					</table>
				</app-accordion-item>
				<app-accordion-item title="{{ 'cloud.title831' | translate }}">
					<table>
					  <thead>
					    <tr>
					      <th scope="col"></th>
					      <th scope="col">Education</th>
					      <th scope="col">{{ 'cloud.title392' | translate }}</th>
					    </tr>
					  </thead>
					  <tbody>
					    <tr>
					      <td data-label="Funcionalidad">{{ 'cloud.title419' | translate }}</td>
					      <td data-label="Google Workspace"><img class="tick" src="../../../../../assets/img/tick.svg" alt=""></td>
					      <td data-label="Google Workspace con eSource"><img class="tick" src="../../../../../assets/img/tick.svg" alt=""></td>
					    </tr>
					    <tr>
					      <td data-label="Funcionalidad">{{ 'cloud.title420' | translate }}</td>
					      <td data-label="Google Workspace"><img class="tick" src="../../../../../assets/img/tick.svg" alt=""></td>
					      <td data-label="Google Workspace con eSource"><img class="tick" src="../../../../../assets/img/tick.svg" alt=""></td>
					    </tr>
					    <tr>
					      <td data-label="Funcionalidad">{{ 'cloud.title421' | translate }}</td>
					      <td data-label="Google Workspace"><img class="tick" src="../../../../../assets/img/tick.svg" alt=""></td>
					      <td data-label="Google Workspace con eSource"><img class="tick" src="../../../../../assets/img/tick.svg" alt=""></td>
					    </tr>
					    <tr>
					      <td data-label="Funcionalidad">{{ 'cloud.title422' | translate }}</td>
					      <td data-label="Google Workspace"><img class="tick" src="../../../../../assets/img/tick.svg" alt=""></td>
					      <td data-label="Google Workspace con eSource"><img class="tick" src="../../../../../assets/img/tick.svg" alt=""></td>
					    </tr>
					    <tr>
					      <td data-label="Funcionalidad">{{ 'cloud.title423' | translate }}</td>
					      <td data-label="Google Workspace"><img class="tick" src="../../../../../assets/img/tick.svg" alt=""></td>
					      <td data-label="Google Workspace con eSource"><img class="tick" src="../../../../../assets/img/tick.svg" alt=""></td>
					    </tr>
					    <tr>
					      <td data-label="Funcionalidad">{{ 'cloud.title424' | translate }}</td>
					      <td data-label="Google Workspace"><img class="tick" src="../../../../../assets/img/tick.svg" alt=""></td>
					      <td data-label="Google Workspace con eSource"><img class="tick" src="../../../../../assets/img/tick.svg" alt=""></td>
					    </tr>
					    <tr>
					      <td data-label="Funcionalidad">{{ 'cloud.title425' | translate }}</td>
					      <td data-label="Google Workspace"><img class="tick" src="../../../../../assets/img/tick.svg" alt=""></td>
					      <td data-label="Google Workspace con eSource"><img class="tick" src="../../../../../assets/img/tick.svg" alt=""></td>
					    </tr>
					    <tr>
					      <td data-label="Funcionalidad">{{ 'cloud.title426' | translate }}</td>
					      <td data-label="Google Workspace"></td>
					      <td data-label="Google Workspace con eSource"><img class="tick" src="../../../../../assets/img/tick.svg" alt=""></td>
					    </tr>
					    <tr>
					      <td data-label="Funcionalidad">{{ 'cloud.title427' | translate }}</td>
					      <td data-label="Google Workspace"></td>
					      <td data-label="Google Workspace con eSource"><img class="tick" src="../../../../../assets/img/tick.svg" alt=""></td>
					    </tr>
					    <tr>
					      <td data-label="Funcionalidad">{{ 'cloud.title428' | translate }}</td>
					      <td data-label="Google Workspace"></td>
					      <td data-label="Google Workspace con eSource"><img class="tick" src="../../../../../assets/img/tick.svg" alt=""></td>
					    </tr>
					  </tbody>
					</table>
				</app-accordion-item>
				<app-accordion-item title="{{ 'cloud.title832' | translate }}">
					<table>
					  <thead>
					    <tr>
					      <th scope="col"></th>
					      <th scope="col">Education</th>
					      <th scope="col">{{ 'cloud.title392' | translate }}</th>
					    </tr>
					  </thead>
					  <tbody>
					    <tr>
					      <td data-label="Funcionalidad">{{ 'cloud.title429' | translate }}</td>
					      <td data-label="Google Workspace"><img class="tick" src="../../../../../assets/img/tick.svg" alt=""></td>
					      <td data-label="Google Workspace con eSource"><img class="tick" src="../../../../../assets/img/tick.svg" alt=""></td>
					    </tr>
					    <tr>
					      <td data-label="Funcionalidad">{{ 'cloud.title430' | translate }}</td>
					      <td data-label="Google Workspace"><img class="tick" src="../../../../../assets/img/tick.svg" alt=""></td>
					      <td data-label="Google Workspace con eSource"><img class="tick" src="../../../../../assets/img/tick.svg" alt=""></td>
					    </tr>
					    <tr>
					      <td data-label="Funcionalidad">{{ 'cloud.title431' | translate }}</td>
					      <td data-label="Google Workspace"><img class="tick" src="../../../../../assets/img/tick.svg" alt=""></td>
					      <td data-label="Google Workspace con eSource"><img class="tick" src="../../../../../assets/img/tick.svg" alt=""></td>
					    </tr>
					    <tr>
					      <td data-label="Funcionalidad">{{ 'cloud.title432' | translate }}</td>
					      <td data-label="Google Workspace"><p>5 por curso</p></td>
					      <td data-label="Google Workspace con eSource"><p>{{ 'cloud.title439' | translate }}</p></td>
					    </tr>
					    <tr>
					      <td data-label="Funcionalidad">{{ 'cloud.title433' | translate }}</td>
					      <td data-label="Google Workspace"></td>
					      <td data-label="Google Workspace con eSource"><img class="tick" src="../../../../../assets/img/tick.svg" alt=""></td>
					    </tr>
					    <tr>
					      <td data-label="Funcionalidad">{{ 'cloud.title434' | translate }}</td>
					      <td data-label="Google Workspace"></td>
					      <td data-label="Google Workspace con eSource"><img class="tick" src="../../../../../assets/img/tick.svg" alt=""></td>
					    </tr>
					  </tbody>
					</table>
				</app-accordion-item>
				<app-accordion-item title="{{ 'cloud.title833' | translate }}">
					<table>
					  <thead>
					    <tr>
					      <th scope="col"></th>
					      <th scope="col">Education</th>
					      <th scope="col">{{ 'cloud.title392' | translate }}</th>
					    </tr>
					  </thead>
					  <tbody>
					    <tr>
					      <td data-label="Funcionalidad">{{ 'cloud.title435' | translate }}</td>
					      <td data-label="Google Workspace"><img class="tick" src="../../../../../assets/img/tick.svg" alt=""></td>
					      <td data-label="Google Workspace con eSource"><img class="tick" src="../../../../../assets/img/tick.svg" alt=""></td>
					    </tr>
					    <tr>
					      <td data-label="Funcionalidad">{{ 'cloud.title436' | translate }}</td>
					      <td data-label="Google Workspace"><img class="tick" src="../../../../../assets/img/tick.svg" alt=""></td>
					      <td data-label="Google Workspace con eSource"><img class="tick" src="../../../../../assets/img/tick.svg" alt=""></td>
					    </tr>
					    <tr>
					      <td data-label="Funcionalidad">{{ 'cloud.title437' | translate }}</td>
					      <td data-label="Google Workspace"><img class="tick" src="../../../../../assets/img/tick.svg" alt=""></td>
					      <td data-label="Google Workspace con eSource"><img class="tick" src="../../../../../assets/img/tick.svg" alt=""></td>
					    </tr>
					    <tr>
					      <td data-label="Funcionalidad">{{ 'cloud.title438' | translate }}</td>
					      <td data-label="Google Workspace"><p>{{ 'cloud.title439' | translate }}</p></td>
					      <td data-label="Google Workspace con eSource"><p>{{ 'cloud.title439' | translate }}</p></td>
					    </tr>
					    <tr>
					      <td data-label="Funcionalidad">{{ 'cloud.title440' | translate }}</td>
					      <td data-label="Google Workspace"><img class="tick" src="../../../../../assets/img/tick.svg" alt=""></td>
					      <td data-label="Google Workspace con eSource"><img class="tick" src="../../../../../assets/img/tick.svg" alt=""></td>
					    </tr>
					    <tr>
					      <td data-label="Funcionalidad">{{ 'cloud.title441' | translate }}</td>
					      <td data-label="Google Workspace"></td>
					      <td data-label="Google Workspace con eSource"><img class="tick" src="../../../../../assets/img/tick.svg" alt=""></td>
					    </tr>
					  </tbody>
					</table>
				</app-accordion-item>
				<app-accordion-item title="{{ 'cloud.title834' | translate }}">
					<table>
					  <thead>
					    <tr>
					      <th scope="col"></th>
					      <th scope="col">Education</th>
					      <th scope="col">{{ 'cloud.title392' | translate }}</th>
					    </tr>
					  </thead>
					  <tbody>
					    <tr>
					      <td data-label="Funcionalidad">{{ 'cloud.title442' | translate }}</td>
					      <td data-label="Google Workspace"><img class="tick" src="../../../../../assets/img/tick.svg" alt=""></td>
					      <td data-label="Google Workspace con eSource"><img class="tick" src="../../../../../assets/img/tick.svg" alt=""></td>
					    </tr>
					    <tr>
					      <td data-label="Funcionalidad">{{ 'cloud.title443' | translate }}</td>
					      <td data-label="Google Workspace"><img class="tick" src="../../../../../assets/img/tick.svg" alt=""></td>
					      <td data-label="Google Workspace con eSource"><img class="tick" src="../../../../../assets/img/tick.svg" alt=""></td>
					    </tr>
					    <tr>
					      <td data-label="Funcionalidad">{{ 'cloud.title444' | translate }}</td>
					      <td data-label="Google Workspace"></td>
					      <td data-label="Google Workspace con eSource"><img class="tick" src="../../../../../assets/img/tick.svg" alt=""></td>
					    </tr>
					  </tbody>
					</table>
				</app-accordion-item>
				<app-accordion-item title="{{ 'cloud.title835' | translate }}">
					<table>
					  <thead>
					    <tr>
					      <th scope="col"></th>
					      <th scope="col">Education</th>
					      <th scope="col">{{ 'cloud.title392' | translate }}</th>
					    </tr>
					  </thead>
					  <tbody>
					    <tr>
					      <td data-label="Funcionalidad">{{ 'cloud.title445' | translate }}</td>
					      <td data-label="Google Workspace"><img class="tick" src="../../../../../assets/img/tick.svg" alt=""></td>
					      <td data-label="Google Workspace con eSource"><img class="tick" src="../../../../../assets/img/tick.svg" alt=""></td>
					    </tr>
					    <tr>
					      <td data-label="Funcionalidad">{{ 'cloud.title446' | translate }}</td>
					      <td data-label="Google Workspace"><img class="tick" src="../../../../../assets/img/tick.svg" alt=""></td>
					      <td data-label="Google Workspace con eSource"><img class="tick" src="../../../../../assets/img/tick.svg" alt=""></td>
					    </tr>
					    <tr>
					      <td data-label="Funcionalidad">{{ 'cloud.title447' | translate }}</td>
					      <td data-label="Google Workspace"><img class="tick" src="../../../../../assets/img/tick.svg" alt=""></td>
					      <td data-label="Google Workspace con eSource"><img class="tick" src="../../../../../assets/img/tick.svg" alt=""></td>
					    </tr>
					    <tr>
					      <td data-label="Funcionalidad">{{ 'cloud.title448' | translate }}</td>
					      <td data-label="Google Workspace"><img class="tick" src="../../../../../assets/img/tick.svg" alt=""></td>
					      <td data-label="Google Workspace con eSource"><img class="tick" src="../../../../../assets/img/tick.svg" alt=""></td>
					    </tr>
					    <tr>
					      <td data-label="Funcionalidad">{{ 'cloud.title449' | translate }}</td>
					      <td data-label="Google Workspace"><img class="tick" src="../../../../../assets/img/tick.svg" alt=""></td>
					      <td data-label="Google Workspace con eSource"><img class="tick" src="../../../../../assets/img/tick.svg" alt=""></td>
					    </tr>
					  </tbody>
					</table>
					
				</app-accordion-item>
				<app-accordion-item title="{{ 'cloud.title836' | translate }}">
					<table>
					  <thead>
					    <tr>
					      <th scope="col"></th>
					      <th scope="col">Education</th>
					      <th scope="col">{{ 'cloud.title392' | translate }}</th>
					    </tr>
					  </thead>
					  <tbody>
					    <tr>
					      <td data-label="Funcionalidad">{{ 'cloud.title450' | translate }}</td>
					      <td data-label="Google Workspace" colspan="2"><p>Ilimitado*</p></td>
					    </tr>
					    <tr>
					      <td data-label="Funcionalidad">{{ 'cloud.title451' | translate }}</td>
					      <td data-label="Google Workspace" colspan="2"><p>25 MB</p></td>
					    </tr>
					    <tr>
					      <td data-label="Funcionalidad">{{ 'cloud.title452' | translate }}</td>
					      <td data-label="Google Workspace" colspan="2"><p>50 MB</p></td>
					    </tr>
					    <tr>
					      <td data-label="Funcionalidad">{{ 'cloud.title453' | translate }}</td>
					      <td data-label="Google Workspace" colspan="2"><p>2000 (500 externos)</p></td>
					    </tr>
					    <tr>
					      <td data-label="Funcionalidad">{{ 'cloud.title454' | translate }}</td>
					      <td data-label="Google Workspace" colspan="2"><p>{{ 'cloud.title457' | translate }}</p></td>
					      
					    </tr>
					    <p>{{ 'cloud.title458' | translate }}</p>
					  </tbody>
					</table>
				</app-accordion-item>
				<app-accordion-item title="{{ 'cloud.title837' | translate }}">
					<table>
					  <thead>
					    <tr>
					      <th scope="col"></th>
					      <th scope="col">Education</th>
					      <th scope="col">{{ 'cloud.title392' | translate }}</th>
					    </tr>
					  </thead>
					  <tbody>
					    <tr>
					      <td data-label="Funcionalidad">{{ 'cloud.title459' | translate }}</td>
					      <td data-label="Google Workspace"><img class="tick" src="../../../../../assets/img/tick.svg" alt=""></td>
					      <td data-label="Google Workspace con eSource"><img class="tick" src="../../../../../assets/img/tick.svg" alt=""></td>
					    </tr>
					    <tr>
					      <td data-label="Funcionalidad">{{ 'cloud.title460' | translate }}</td>
					      <td data-label="Google Workspace"><img class="tick" src="../../../../../assets/img/tick.svg" alt=""></td>
					      <td data-label="Google Workspace con eSource"><img class="tick" src="../../../../../assets/img/tick.svg" alt=""></td>
					    </tr>
					    <tr>
					      <td data-label="Funcionalidad">{{ 'cloud.title461' | translate }}</td>
					      <td data-label="Google Workspace"><img class="tick" src="../../../../../assets/img/tick.svg" alt=""></td>
					      <td data-label="Google Workspace con eSource"><img class="tick" src="../../../../../assets/img/tick.svg" alt=""></td>
					    </tr>
					    <tr>
					      <td data-label="Funcionalidad">{{ 'cloud.title462' | translate }}</td>
					      <td data-label="Google Workspace"><img class="tick" src="../../../../../assets/img/tick.svg" alt=""></td>
					      <td data-label="Google Workspace con eSource"><img class="tick" src="../../../../../assets/img/tick.svg" alt=""></td>
					    </tr>
					    <tr>
					      <td data-label="Funcionalidad">{{ 'cloud.title463' | translate }}</td>
					      <td data-label="Google Workspace"><img class="tick" src="../../../../../assets/img/tick.svg" alt=""></td>
					      <td data-label="Google Workspace con eSource"><img class="tick" src="../../../../../assets/img/tick.svg" alt=""></td>
					    </tr>
					    <tr>
					      <td data-label="Funcionalidad">{{ 'cloud.title464' | translate }}</td>
					      <td data-label="Google Workspace"><img class="tick" src="../../../../../assets/img/tick.svg" alt=""></td>
					      <td data-label="Google Workspace con eSource"><img class="tick" src="../../../../../assets/img/tick.svg" alt=""></td>
					    </tr>
					    <tr>
					      <td data-label="Funcionalidad">{{ 'cloud.title465' | translate }}</td>
					      <td data-label="Google Workspace"><img class="tick" src="../../../../../assets/img/tick.svg" alt=""></td>
					      <td data-label="Google Workspace con eSource"><img class="tick" src="../../../../../assets/img/tick.svg" alt=""></td>
					    </tr>
					    <tr>
					      <td data-label="Funcionalidad">{{ 'cloud.title466' | translate }}</td>
					      <td data-label="Google Workspace"><img class="tick" src="../../../../../assets/img/tick.svg" alt=""></td>
					      <td data-label="Google Workspace con eSource"><img class="tick" src="../../../../../assets/img/tick.svg" alt=""></td>
					    </tr>
					    <tr>
					      <td data-label="Funcionalidad">{{ 'cloud.title467' | translate }}</td>
					      <td data-label="Google Workspace"><img class="tick" src="../../../../../assets/img/tick.svg" alt=""></td>
					      <td data-label="Google Workspace con eSource"><img class="tick" src="../../../../../assets/img/tick.svg" alt=""></td>
					    </tr>
					    <tr>
					      <td data-label="Funcionalidad">{{ 'cloud.title468' | translate }}</td>
					      <td data-label="Google Workspace"><img class="tick" src="../../../../../assets/img/tick.svg" alt=""></td>
					      <td data-label="Google Workspace con eSource"><img class="tick" src="../../../../../assets/img/tick.svg" alt=""></td>
					    </tr>
					    <tr>
					      <td data-label="Funcionalidad">{{ 'cloud.title469' | translate }}</td>
					      <td data-label="Google Workspace"></td>
					      <td data-label="Google Workspace con eSource"><img class="tick" src="../../../../../assets/img/tick.svg" alt=""></td>
					    </tr>
					    <tr>
					      <td data-label="Funcionalidad">{{ 'cloud.title470' | translate }}</td>
					      <td data-label="Google Workspace"><img class="tick" src="../../../../../assets/img/tick.svg" alt=""></td>
					      <td data-label="Google Workspace con eSource"><img class="tick" src="../../../../../assets/img/tick.svg" alt=""></td>
					    </tr>
					    <tr>
					      <td data-label="Funcionalidad">{{ 'cloud.title471' | translate }}</td>
					      <td data-label="Google Workspace"></td>
					      <td data-label="Google Workspace con eSource"><img class="tick" src="../../../../../assets/img/tick.svg" alt=""></td>
					    </tr>
					  </tbody>
					</table>
				</app-accordion-item>
				<app-accordion-item title="{{ 'cloud.title838' | translate }}">
					<table>
					  <thead>
					    <tr>
					      <th scope="col"></th>
					      <th scope="col">Education</th>
					      <th scope="col">{{ 'cloud.title392' | translate }}</th>
					    </tr>
					  </thead>
					  <tbody>
					    <tr>
					      <td data-label="Funcionalidad">{{ 'cloud.title472' | translate }}</td>
					      <td data-label="Google Workspace"><img class="tick" src="../../../../../assets/img/tick.svg" alt=""></td>
					      <td data-label="Google Workspace con eSource"><img class="tick" src="../../../../../assets/img/tick.svg" alt=""></td>
					    </tr>
					    <tr>
					      <td data-label="Funcionalidad">{{ 'cloud.title473' | translate }}</td>
					      <td data-label="Google Workspace"><img class="tick" src="../../../../../assets/img/tick.svg" alt=""></td>
					      <td data-label="Google Workspace con eSource"><img class="tick" src="../../../../../assets/img/tick.svg" alt=""></td>
					    </tr>
					    <tr>
					      <td data-label="Funcionalidad">{{ 'cloud.title474' | translate }}</td>
					      <td data-label="Google Workspace"><img class="tick" src="../../../../../assets/img/tick.svg" alt=""></td>
					      <td data-label="Google Workspace con eSource"><img class="tick" src="../../../../../assets/img/tick.svg" alt=""></td>
					    </tr>
					    <tr>
					      <td data-label="Funcionalidad">{{ 'cloud.title475' | translate }}</td>
					      <td data-label="Google Workspace"><img class="tick" src="../../../../../assets/img/tick.svg" alt=""></td>
					      <td data-label="Google Workspace con eSource"><img class="tick" src="../../../../../assets/img/tick.svg" alt=""></td>
					    </tr>
					    <tr>
					      <td data-label="Funcionalidad">{{ 'cloud.title476' | translate }}</td>
					      <td data-label="Google Workspace"><img class="tick" src="../../../../../assets/img/tick.svg" alt=""></td>
					      <td data-label="Google Workspace con eSource"><img class="tick" src="../../../../../assets/img/tick.svg" alt=""></td>
					    </tr>
					    <tr>
					      <td data-label="Funcionalidad">{{ 'cloud.title477' | translate }}</td>
					      <td data-label="Google Workspace"><img class="tick" src="../../../../../assets/img/tick.svg" alt=""></td>
					      <td data-label="Google Workspace con eSource"><img class="tick" src="../../../../../assets/img/tick.svg" alt=""></td>
					    </tr>
					  </tbody>
					</table>
				</app-accordion-item>
				<app-accordion-item title="{{ 'cloud.title839' | translate }}">
					<table>
					  <thead>
					    <tr>
					      <th scope="col"></th>
					      <th scope="col">Education</th>
					      <th scope="col">{{ 'cloud.title392' | translate }}</th>
					    </tr>
					  </thead>
					  <tbody>
					    <tr>
					      <td data-label="Funcionalidad">{{ 'cloud.title478' | translate }}</td>
					      <td data-label="Google Workspace"><img class="tick" src="../../../../../assets/img/tick.svg" alt=""></td>
					      <td data-label="Google Workspace con eSource"><img class="tick" src="../../../../../assets/img/tick.svg" alt=""></td>
					    </tr>
					    <tr>
					      <td data-label="Funcionalidad">{{ 'cloud.title479' | translate }}</td>
					      <td data-label="Google Workspace"><img class="tick" src="../../../../../assets/img/tick.svg" alt=""></td>
					      <td data-label="Google Workspace con eSource"><img class="tick" src="../../../../../assets/img/tick.svg" alt=""></td>
					    </tr>
					    <tr>
					      <td data-label="Funcionalidad">{{ 'cloud.title480' | translate }}</td>
					      <td data-label="Google Workspace"><img class="tick" src="../../../../../assets/img/tick.svg" alt=""></td>
					      <td data-label="Google Workspace con eSource"><img class="tick" src="../../../../../assets/img/tick.svg" alt=""></td>
					    </tr>
					    <tr>
					      <td data-label="Funcionalidad">{{ 'cloud.title481' | translate }}</td>
					      <td data-label="Google Workspace"><img class="tick" src="../../../../../assets/img/tick.svg" alt=""></td>
					      <td data-label="Google Workspace con eSource"><img class="tick" src="../../../../../assets/img/tick.svg" alt=""></td>
					    </tr>
					    <tr>
					      <td data-label="Funcionalidad">{{ 'cloud.title482' | translate }}</td>
					      <td data-label="Google Workspace"><img class="tick" src="../../../../../assets/img/tick.svg" alt=""></td>
					      <td data-label="Google Workspace con eSource"><img class="tick" src="../../../../../assets/img/tick.svg" alt=""></td>
					    </tr>
					    <tr>
					      <td data-label="Funcionalidad">{{ 'cloud.title483' | translate }}</td>
					      <td data-label="Google Workspace"><img class="tick" src="../../../../../assets/img/tick.svg" alt=""></td>
					      <td data-label="Google Workspace con eSource"><img class="tick" src="../../../../../assets/img/tick.svg" alt=""></td>
					    </tr>
					    <tr>
					      <td data-label="Funcionalidad">{{ 'cloud.title484' | translate }}</td>
					      <td data-label="Google Workspace"><img class="tick" src="../../../../../assets/img/tick.svg" alt=""></td>
					      <td data-label="Google Workspace con eSource"><img class="tick" src="../../../../../assets/img/tick.svg" alt=""></td>
					    </tr>
					    <tr>
					      <td data-label="Funcionalidad">{{ 'cloud.title485' | translate }}</td>
					      <td data-label="Google Workspace"></td>
					      <td data-label="Google Workspace con eSource"><img class="tick" src="../../../../../assets/img/tick.svg" alt=""></td>
					    </tr>
					  </tbody>
					</table>
				</app-accordion-item>
				<app-accordion-item title="{{ 'cloud.title840' | translate }}">
					<table>
					  <thead>
					    <tr>
					      <th scope="col"></th>
					      <th scope="col">Education</th>
					      <th scope="col">{{ 'cloud.title392' | translate }}</th>
					    </tr>
					  </thead>
					  <tbody>
					    <tr>
					      <td data-label="Funcionalidad">{{ 'cloud.title486' | translate }}</td>
					      <td data-label="Google Workspace"><p>100</p></td>
					      <td data-label="Google Workspace con eSource"><p>250</p></td>
					    </tr>
					    <tr>
					      <td data-label="Funcionalidad">{{ 'cloud.title487' | translate }}</td>
					      <td data-label="Google Workspace"><img class="tick" src="../../../../../assets/img/tick.svg" alt=""></td>
					      <td data-label="Google Workspace con eSource"><img class="tick" src="../../../../../assets/img/tick.svg" alt=""></td>
					    </tr>
					    <tr>
					      <td data-label="Funcionalidad">{{ 'cloud.title488' | translate }}</td>
					      <td data-label="Google Workspace"><img class="tick" src="../../../../../assets/img/tick.svg" alt=""></td>
					      <td data-label="Google Workspace con eSource"><img class="tick" src="../../../../../assets/img/tick.svg" alt=""></td>
					    </tr>
					    <tr>
					      <td data-label="Funcionalidad">{{ 'cloud.title489' | translate }}</td>
					      <td data-label="Google Workspace"><img class="tick" src="../../../../../assets/img/tick.svg" alt=""></td>
					      <td data-label="Google Workspace con eSource"><img class="tick" src="../../../../../assets/img/tick.svg" alt=""></td>
					    </tr>
					    <tr>
					      <td data-label="Funcionalidad">{{ 'cloud.title490' | translate }}</td>
					      <td data-label="Google Workspace"></td>
					      <td data-label="Google Workspace con eSource"><img class="tick" src="../../../../../assets/img/tick.svg" alt=""></td>
					    </tr>
					    <tr>
					      <td data-label="Funcionalidad">{{ 'cloud.title491' | translate }}</td>
					      <td data-label="Google Workspace"><img class="tick" src="../../../../../assets/img/tick.svg" alt=""></td>
					      <td data-label="Google Workspace con eSource"><img class="tick" src="../../../../../assets/img/tick.svg" alt=""></td>
					    </tr>
					    <tr>
					      <td data-label="Funcionalidad">{{ 'cloud.title492' | translate }}</td>
					      <td data-label="Google Workspace"></td>
					      <td data-label="Google Workspace con eSource"><p>100</p></td>
					    </tr>
					    <tr>
					      <td data-label="Funcionalidad">{{ 'cloud.title493' | translate }}</td>
					      <td class="tfl" data-label="Google Workspace">
					      	<img class="tick" src="../../../../../assets/img/tick.svg" alt="">
					      	<p>*</p>
					      </td>
					      <td data-label="Google Workspace con eSource"><img class="tick" src="../../../../../assets/img/tick.svg" alt=""></td>
					    </tr>
					    <tr>
					      <td data-label="Funcionalidad">{{ 'cloud.title494' | translate }}</td>
					      <td data-label="Google Workspace"></td>
					      <td data-label="Google Workspace con eSource"><img class="tick" src="../../../../../assets/img/tick.svg" alt=""></td>
					    </tr>
					    <tr>
					      <td data-label="Funcionalidad">{{ 'cloud.title495' | translate }}</td>
					      <td data-label="Google Workspace"></td>
					      <td data-label="Google Workspace con eSource"><img class="tick" src="../../../../../assets/img/tick.svg" alt=""></td>
					    </tr>
					    <tr>
					      <td data-label="Funcionalidad">{{ 'cloud.title496' | translate }}</td>
					      <td data-label="Google Workspace"></td>
					      <td data-label="Google Workspace con eSource"><img class="tick" src="../../../../../assets/img/tick.svg" alt=""></td>
					    </tr>
					    <tr>
					      <td data-label="Funcionalidad">{{ 'cloud.title497' | translate }}</td>
					      <td data-label="Google Workspace"></td>
					      <td data-label="Google Workspace con eSource"><img class="tick" src="../../../../../assets/img/tick.svg" alt=""></td>
					    </tr>
					    <p>{{ 'cloud.title498' | translate }}</p>
					  </tbody>
					</table>
				</app-accordion-item>
				<app-accordion-item title="{{ 'cloud.title841' | translate }}">
					<table>
					  <thead>
					    <tr>
					      <th scope="col"></th>
					      <th scope="col">Education</th>
					      <th scope="col">{{ 'cloud.title392' | translate }}</th>
					    </tr>
					  </thead>
					  <tbody>
					    <tr>
					      <td data-label="Funcionalidad">{{ 'cloud.title499' | translate }}</td>
					      <td data-label="Google Workspace"><img class="tick" src="../../../../../assets/img/tick.svg" alt=""></td>
					      <td data-label="Google Workspace con eSource"><img class="tick" src="../../../../../assets/img/tick.svg" alt=""></td>
					    </tr>
					    <tr>
					      <td data-label="Funcionalidad">{{ 'cloud.title500' | translate }}</td>
					      <td data-label="Google Workspace"><img class="tick" src="../../../../../assets/img/tick.svg" alt=""></td>
					      <td data-label="Google Workspace con eSource"><img class="tick" src="../../../../../assets/img/tick.svg" alt=""></td>
					    </tr>
					    <tr>
					      <td data-label="Funcionalidad">{{ 'cloud.title501' | translate }}</td>
					      <td data-label="Google Workspace"><img class="tick" src="../../../../../assets/img/tick.svg" alt=""></td>
					      <td data-label="Google Workspace con eSource"><img class="tick" src="../../../../../assets/img/tick.svg" alt=""></td>
					    </tr>
					    <tr>
					      <td data-label="Funcionalidad">{{ 'cloud.title502' | translate }}</td>
					      <td data-label="Google Workspace"><img class="tick" src="../../../../../assets/img/tick.svg" alt=""></td>
					      <td data-label="Google Workspace con eSource"><img class="tick" src="../../../../../assets/img/tick.svg" alt=""></td>
					    </tr>
					    <tr>
					      <td data-label="Funcionalidad">{{ 'cloud.title503' | translate }}</td>
					      <td data-label="Google Workspace"><img class="tick" src="../../../../../assets/img/tick.svg" alt=""></td>
					      <td data-label="Google Workspace con eSource"><img class="tick" src="../../../../../assets/img/tick.svg" alt=""></td>
					    </tr>
					    <tr>
					      <td data-label="Funcionalidad">{{ 'cloud.title504' | translate }}</td>
					      <td data-label="Google Workspace"></td>
					      <td data-label="Google Workspace con eSource"><img class="tick" src="../../../../../assets/img/tick.svg" alt=""></td>
					    </tr>
					  </tbody>
					</table>
				</app-accordion-item>
			</app-accordion>
		</div>

		</section>	

	</div>
</div>

<div (click)="scroll(formbox)">
	<app-banner></app-banner>
</div>


<div class="gray">
	<div class="content-area">
		<div class="wrap">
			<section class="video">
				<div class="w100">
					<div class="frame">
						<iframe width="560" height="315" src="https://www.youtube.com/embed/HYpMf8D7BoM" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
					</div>
					<div class="text">
						<h3>{{ 'cloud.title505' | translate }}<br>{{ 'cloud.title506' | translate }}</h3>
					</div>
				</div>
			</section>	
		</div>
	</div>
</div>



<div class="light">
<div class="content-area">
	<div class="wrap">
		<section class="features">
			<article>
				<div class="iflex">
					<div class="piece">
						<div class="stitle">
							<img class="sgoogle" src="../../../../../assets/img/Google_for_Education_logo.svg" alt="google education"> 
						</div>
						<h3>{{ 'cloud.title507' | translate }}</h3>
						<ul>
							<li>{{ 'cloud.title508' | translate }}</li>
							<li>{{ 'cloud.title509' | translate }}</li>
							<li>{{ 'cloud.title510' | translate }}</li>
							<li>{{ 'cloud.title511' | translate }}</li>
						</ul>
					</div>
<!-- 					<div class="piece bdown">
						<div class="card">
							<div class="sflex">
								<div class="spiece padded">
									<h2>Google Workspace for Education</h2>
									<ul>
										<li>Bandeja de entrada de correo escolar personalizada</li>
										<li>Almacenamiento de datos ilimitado en Google Drive</li>
										<li>Todas las funcionalidades de Google Workspace Collaboration</li>
										<li>Auditoría de correo electrónico y de Drive para administradores</li>
										<li>Participación en todas las actividades de Classroom y Meet organizadas y controladas por profesores</li>
									</ul>
									<div class="button" (click)="scroll(formbox)">Suscripción gratuita</div>
								</div>
								<div class="spiece">
									<div class="foto1"></div>
								</div>
							</div>
						</div>
					</div> -->
				</div>
			</article>
			<article class="padd8">
				<div class="barra">
					<div class="zflex">
						<div class="box22">

							<div class="iheader">
								<p>Google for Education</p>
								<h3>Google Workspace for Education Standard</h3>
							</div>
							<p>{{ 'cloud.title512' | translate }}</p>
							<div class="ifooter">
								<h4>3.00 USD</h4>
								<h5>{{ 'cloud.title513' | translate }}</h5>
								<div class="button" (click)="scroll(formbox)">{{ 'cloud.title514' | translate }}</div>
							</div>
							
						</div>
						<div class="box22">

							<div class="iheader">
								<p>Google for Education</p>
								<h3>Teaching and Learning Upgrade</h3>
							</div>
							<p>{{ 'cloud.title515' | translate }}</p>
							<div class="ifooter">
								<h4>4.00 USD</h4>
								<h5>{{ 'cloud.title516' | translate }}</h5>
								<div class="button" (click)="scroll(formbox)">{{ 'cloud.title514' | translate }}</div>
							</div>
							
						</div>
						<div class="box22">

							<div class="iheader">
								<p>Google for Education</p>
								<h3>Google Workspace for Education Plus</h3>
							</div>
							<p>{{ 'cloud.title517' | translate }}</p>
							<div class="ifooter">
								<h4>5.00 USD</h4>
								<h5>{{ 'cloud.title513' | translate }}</h5>
								<div class="button" (click)="scroll(formbox)">{{ 'cloud.title514' | translate }}</div>
							</div>
							
						</div>
					</div>		
				</div>
				




			</article>
			<div class="space2"></div>
			<article class="padd9">
				<div class="card">
					<div class="sflex">
						<div class="spiece padded">
							<img class="classroom" src="../../../../../assets/img/gclassroom.svg" alt="">
							<h2>{{ 'cloud.title518' | translate }}</h2>
							<p>{{ 'cloud.title519' | translate }}</p>
							<ul>
								<li>{{ 'cloud.title520' | translate }}</li>
								<li>{{ 'cloud.title521' | translate }}</li>
								<li>{{ 'cloud.title522' | translate }}</li>
								<li>{{ 'cloud.title523' | translate }}</li>
							</ul>
						</div>
						<div class="spiece">
							<div class="foto2"></div>
							
						</div>
					</div>
				</div>
			</article>
			
			
		</section>


		<section id="second">

			<div class="flex21 website">
				<div class="element21">
					<div class="high">
						<img class="imob" src="../../../../../assets/img/aula-mobile.svg" alt="aula mobile">
						<h3>{{ 'cloud.title524' | translate }}</h3>
						
					</div>
					<div class="low">
						<h3>{{ 'cloud.title525' | translate }}</h3>
					</div>
				</div>
				<div class="element21">
					<div class="high center">
						<img class="imob2" src="../../../../../assets/img/screen-icon.svg" alt="screen icon">
						
						<h3>{{ 'cloud.title526' | translate }}</h3>
					</div>
					<div class="low">
						<h3>{{ 'cloud.title527' | translate }}</h3>
					</div>
				</div>
				<div class="element21">
					<div class="high">
						<img class="imob3" src="../../../../../assets/img/students-icon.svg" alt="students icon">
						<h3>{{ 'cloud.title528' | translate }}</h3>
					</div>
					<div class="low">
						<h3>{{ 'cloud.title529' | translate }}</h3>
					</div>
				</div>
			</div>

		</section>



	</div>
</div>
</div>

<div class="content-area">
	<div class="wrap">
		<section class="intereses">
			<div class="wrapper">
	            <h3>{{ 'cloud.title530' | translate }}</h3>
	            <div class="card-wrapper">
	                <div class="card" routerLink="/workspace">
	                    <img class="img-iconb" src="../../../../../assets/img/Google_Workspace_Logo.svg" alt="Cloud">
	                    <img class="arrow" src="../../../../assets/img/blue-arrow.svg" alt="arrow">
	                </div>
	                <div class="card" routerLink="/rackspace">
	                	<div class="box22">
	                		<div class="barra22">
	                			<img class="img-iconb" src="../../../../../assets/img/rackspace/Rackspace_Technology_Logo_RGB_BLK.webp" alt="Maps">
	                		</div>
	                		<div class="barra22">
	                			<p>Email</p>
	                		</div>
	                	</div>
	                    <img class="arrow" src="../../../../assets/img/blue-arrow.svg" alt="arrow">
	                </div>
	                
	            </div>
	        </div>
		</section>
	</div>
</div>




<div #formbox style="margin-bottom: -40px;">
	<app-form></app-form>
</div>
